import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { X, Menu, Check, ForwardIcon, ArrowDownToLine, MessageCircleIcon } from 'lucide-react'
import { ScrollArea, ScrollBar } from 'src/components/ui/scroll-area'
import { format } from 'date-fns'
import { YYYYMMDDtoDate } from 'src/functions/format'
import { getWindevLang } from 'src/lib/lang'
import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent } from 'src/components/ui/tooltip'
import { InfoSheet } from 'src/pages/PublicDocument'
import { MailPopup } from 'src/pages/PublicDocument'
import Remarks from 'src/components/workflow/Remarks';
import Communication from 'src/components/workflow/Communication'
import Attachments from 'src/components/workflow/Attachments'
import Preview from 'src/components/files/Preview';

type P = {
    activeDocument:any;
    docid_added_wf:any;
    data:any;
    filteredDocuments:any;
    active_index:any;
    communication:any;
    refetchCommunication:any;
    handleDownloadFile:any;
    setactive_index:any;
    doctypes:any;
    metatypes:any;
    getMetatypeOMS:any;
    setactive_approve:any;
    setactive_forward:any;
    setactive_reject:any
}

const DefaultView = ({activeDocument, docid_added_wf, data, filteredDocuments, active_index, communication, refetchCommunication, handleDownloadFile, setactive_index, doctypes, metatypes, getMetatypeOMS, setactive_approve, setactive_forward, setactive_reject}:P) => {
    const { t, i18n } = useTranslation()

    const [open_sidebar, setopen_sidebar] = useState(true);

    const doctype:DoctypeObject = Array.isArray(doctypes) ? doctypes.find(i => i?.doctype === activeDocument?.doctype) : {}
    const doctypeRights = (doctype && 'rights' in doctype) ? doctype?.rights[0] : null

  return (
    <div className='relative flex flex-row w-full h-full overflow-auto'>
        {/* List documents */}
        {(docid_added_wf.length === data?.documents?.length) && 
        <div className='flex flex-col items-center justify-center w-full gap-10'>
            <p className='text-4xl font-bold lg:text-7xl'>{t('Bedankt')}.</p>
            <p>{t('Alle documenten zijn behandeld')}</p>
        </div>
        }

        {!(docid_added_wf.length === (data?.documents && data?.documents?.length)) && 
        <>
        <div className={`sticky top-0 md:relative z-20  ${open_sidebar ? 'bg-slate-50 border-r' : 'bottom-4'} overflow-auto`}>
            <button onClick={()=>{setopen_sidebar(!open_sidebar)}} className='flex items-center justify-center w-10 h-10 mx-4 mt-4 rounded-full min-w-10 md:hidden bg-slate-200 text-slate-600'>{open_sidebar ? <X className='w-4 h-4'/> : <Menu className='w-4 h-4'/>}</button>
            
            {open_sidebar && 
            <ScrollArea className='px-4 bg-slate-50'>
                <div className='h-[calc(100dvh-5rem)] w-fit min-w-[250px] max-w-[400px] flex flex-col py-4 gap-4'>
                    {data && filteredDocuments && filteredDocuments.map((document:any, index:any)=>(
                        <div onClick={()=>{setactive_index(index)}} className={`${active_index === index ? 'bg-primary border-primary' : 'bg-slate-100 hover:bg-slate-200'} duration-300 p-4 rounded-md border cursor-pointer `} key={`${document.docid}-${index}`}>
                            <div className='flex items-center justify-between'>
                                <p className={`${active_index === index ? 'text-white' : 'text-slate-700'} font-medium`}>{document.filename}</p>
                                {document?.remarks?.length > 0 && <MessageCircleIcon className={`${active_index === index ? 'text-white' : 'text-slate-700'} w-4 h-4`}/>}
                            </div>
                            <p className={`${active_index === index ? 'text-white' : 'text-slate-400'} text-sm`}>{format(YYYYMMDDtoDate(document.docdate), "dd/MM/yyyy")}</p>
                            {document?.metadata && 
                            <div className={`flex items-center flex-wrap gap-1 mt-2`}>
                                <p className={`${active_index === index ? 'text-white' : 'text-slate-400'} border rounded-full px-1 text-xs flex items-center gap-1`}>
                                    <span className='font-medium'>Type:</span> 
                                    {doctypes ? (doctypes.find((i:any)=>i.doctype===document.doctype)?.docoms?.find((i:any)=>i.nationid===getWindevLang(i18n.language))?.oms) : document.doctype}
                                </p>
                                {document.metadata.map((md:any, id:any)=>{
                                    let showMetadata = false;
                                    const metatype = Array.isArray(metatypes) ? metatypes.find(m=>m.metatype===md.metatype) : undefined
                                    if(metatype){
                                        showMetadata = metatype.columndisplay
                                    }
                                    if(!showMetadata){ return <React.Fragment key={`${md.metatype}-${id}`}></React.Fragment> }
                                    return (
                                        <p className={`${active_index === index ? 'text-white' : 'text-slate-400'} border rounded-full px-1 text-xs flex items-center gap-1`} key={`${md.metatype}-${id}`}>
                                            <span className='font-medium'>{getMetatypeOMS(md.metatype)}:</span> 
                                            {md.metavalue}
                                        </p>
                                    )
                                })}
                            </div>}
                        </div>
                    ))}
                </div>
            </ScrollArea>
            }
        </div>

        <div className='w-full h-full p-4 overflow-auto'>
            <div>
                {/* Header document preview */}
                <div className='sticky top-0 z-20 flex items-center justify-between px-4 sm:px-10'>
                    {(filteredDocuments[active_index] && filteredDocuments[active_index].options.wf === 1) && 
                        <div className='flex items-center gap-2 p-1 bg-white border border-solid rounded-full'>
                            <TooltipProvider delayDuration={0}>
                                <Tooltip>
                                    <TooltipTrigger asChild><button onClick={()=>{ setactive_approve(filteredDocuments[active_index]) }} className='flex items-center justify-center w-10 h-10 rounded-full hover:bg-emerald-100'><Check className='w-5 text-emerald-500'/></button></TooltipTrigger>
                                    <TooltipContent>{t('Document goedkeuren')}</TooltipContent>
                                </Tooltip>

                                <Tooltip>
                                    <TooltipTrigger asChild><button onClick={()=>{ setactive_reject(filteredDocuments[active_index]) }} className='flex items-center justify-center w-10 h-10 rounded-full hover:bg-red-100'><X className='w-5 text-red-500'/></button></TooltipTrigger>
                                    <TooltipContent>{t('Document afkeuren')}</TooltipContent>
                                </Tooltip>

                                <Tooltip>
                                    <TooltipTrigger asChild><button onClick={()=>{ setactive_forward(filteredDocuments[active_index]) }} className='flex items-center justify-center w-10 h-10 rounded-full hover:bg-neutral-200'><ForwardIcon className='w-5 h-5 text-neutral-600'/></button></TooltipTrigger>
                                    <TooltipContent>{t('Workflow doorsturen')}</TooltipContent>
                                </Tooltip>
                            </TooltipProvider>
                        </div>
                    }
                    {(filteredDocuments[active_index] && data) && 
                    <div className='flex items-center p-1 bg-white border rounded-full'>
                        {metatypes && <InfoSheet document={filteredDocuments[active_index]} metatypes={metatypes} />    }
                        {((filteredDocuments[active_index].options.wf === 1) || (doctypeRights?.print === 1 && doctypeRights?.email === 1)) && <>{(activeDocument && data) && <MailPopup document={activeDocument} result={data}/>}</>}        
                        {((filteredDocuments[active_index].options.wf === 1) || (doctypeRights?.print === 1 && doctypeRights?.email === 1)) && <>{activeDocument && <button onClick={()=>handleDownloadFile(activeDocument)} className='flex items-center justify-center w-10 h-10 bg-white rounded-full hover:bg-slate-200'><ArrowDownToLine className='w-5 text-slate-500'/></button>}</>}
                        {(activeDocument && filteredDocuments[active_index].attachments) && <Attachments attachments={filteredDocuments[active_index].attachments} />}
                        {(activeDocument && filteredDocuments[active_index].remarks?.length > 0) && <Remarks remarks={filteredDocuments[active_index].remarks} />}
                        {(doctypeRights?.read_only !== 1 || doctypeRights?.full_control === 1 || (filteredDocuments[active_index].options.wf === 1)) && <>{(activeDocument) && <Communication communication={communication} document={filteredDocuments[active_index]} refetch={()=>{ refetchCommunication() }}/>}</>}
                    </div>     
                    }
                </div>
                
                <div className='w-full h-full py-10 mx-4 sm:mx-auto sm:w-fit'>
                {/* Preview document */}
                {data && 
                    (filteredDocuments[active_index] 
                        ? <Preview docid={filteredDocuments[active_index].docid} filename={filteredDocuments[active_index].filename} />
                        : <p>Document niet gevonden</p>
                    )
                }
                </div>
            </div>
        </div>
        </>
        }
    </div>
  )
}

export default DefaultView